export default __webpack_public_path__ + "static/heroSectionBg-c8e479505933f03f4cc40fe9bdabd7ce.png";